import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiamondStackreact = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 22,
	viewBox: "0 0 20 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "diamond-stack",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "icon",
			children: [/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M9.92955 3.95698L4.44386 7.3764L9.92955 10.7958L15.5981 7.3764L9.92955 3.95698ZM9.32944 1.90774C9.69298 1.68114 10.1373 1.67773 10.5036 1.89874L17.6564 6.21348C18.491 6.71695 18.491 8.03584 17.6564 8.53931L10.5036 12.8541C10.1373 13.0751 9.69298 13.0717 9.32944 12.845L2.40739 8.53031C1.59234 8.02226 1.59234 6.73053 2.40739 6.22248L9.32944 1.90774Z",
				fill: "#363F89"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M1.65444 10.59C1.90351 10.0762 2.484 9.88191 2.95101 10.1559L9.91416 14.2409L16.6334 10.163C17.0969 9.88178 17.6798 10.067 17.9355 10.5768C18.1912 11.0865 18.0228 11.7278 17.5593 12.009L9.92965 16.6395L2.04905 12.0162C1.58204 11.7422 1.40537 11.1037 1.65444 10.59ZM1.65444 14.3998C1.90351 13.8861 2.484 13.6918 2.95101 13.9658L9.91416 18.0508L16.6334 13.9729C17.0969 13.6917 17.6798 13.8769 17.9355 14.3867C18.1912 14.8964 18.0228 15.5377 17.5593 15.8189L9.92965 20.4494L2.04905 15.8261C1.58204 15.5521 1.40537 14.9136 1.65444 14.3998Z",
				fill: "#363F89"
			})]
		})
	})
});
export default SvgDiamondStackreact;
